import type TemplateDocumentStore from 'stores/Template';
import { DynamicPropertyType } from 'types/DynamicPropertyType';

import { getOwningCreative, makeCSVImportError } from '../tree';
import type DynamicGroup from './Group';
import { DynamicProperty } from './Property';

export default class Template extends DynamicProperty<string> {
  type = DynamicPropertyType.TEMPLATE;
  value = '';

  constructor(parent: DynamicGroup, name: string, value: string) {
    super(parent, name, value);
    // Not redundant: the `value = ''` initializer above runs after super()
    // and clobbers what it assigned. Group.create puts back any non-null
    // value afterwards, but not null - which is what adding a property from
    // the UI passes - so this is what keeps a new Template's value equal to
    // its initialValue.
    this.value = value;
    // this.becomeObservable();
  }

  // label, getPreviewData and getCSVData give the same result as
  // DynamicProperty's defaults, which all return getString(). They are spelled
  // out to mirror Asset, where they differ: Asset's label and CSV data are the
  // asset's path, but its string and preview data are its URL.
  get label() {
    return this.templateName ?? '';
  }

  getString = () => {
    return this.templateName ?? '';
  };

  getPreviewData = () => {
    return this.templateName ?? '';
  };

  setUsingCSV = (value: string) => {
    // As in Asset.setUsingCSV: no owning creative resolves to the same
    // import error as a name that matches no template.
    const template = getOwningCreative(this)?.templates.getByName(value);
    if (!template) {
      throw makeCSVImportError(
        this,
        `Invalid or missing template: ${JSON.stringify(value)}`
      );
    }
    this.set(template.id);
  };

  getCSVData = () => {
    return this.templateName ?? '';
  };

  private get templateStore(): TemplateDocumentStore | undefined {
    return getOwningCreative(this)?.templates.getById(this.value);
  }

  private get templateName() {
    return this.templateStore?.data.name;
  }

  public get templateId() {
    return this.templateStore?.id;
  }

  public getHostedURL() {
    return this.templateStore?.getHostedURL();
  }
}
